import React, { createContext, useCallback, useContext, useState } from 'react';
import { Toast } from '../components/ui/Toast';
interface ToastContextValue {
  showToast: (message: string) => void;
}
const ToastContext = createContext<ToastContextValue>({
  showToast: () => {}
});
export function ToastProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [message, setMessage] = useState<string | null>(null);
  const showToast = useCallback((next: string) => setMessage(next), []);
  const dismiss = useCallback(() => setMessage(null), []);
  return <ToastContext.Provider value={{
    showToast
  }} data-id="element-607" data-mp="323yep2zlc7ps">
      {children}
      <Toast message={message} onDismiss={dismiss} data-id="element-608" data-mp="3g4hoofnm9nul" />
    </ToastContext.Provider>;
}
export function useToast() {
  return useContext(ToastContext);
}